class AccordionTab extends HTMLElement {
    constructor() {
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.accordion__content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }
    onClick(e) {
        e.preventDefault();
        this.details.style.overflow = 'hidden';
        if (this.isClosing || !this.details.open) {
            this.closeAllTabs();
            this.open();
        }
        else if (this.isExpanding || this.details.open) {
            this.shrink();
        }
    }
    shrink() {
        this.isClosing = true;
        const summaryStyle = window.getComputedStyle(this.summary);
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.details.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 250,
            easing: 'ease'
        });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(() => this.expand());
    }
    closeAllTabs() {

        let parent = this.closest('accordion-tab').parentNode;
        let tabs = parent.querySelectorAll('accordion-tab');
        tabs.forEach(el => {
            el.details.open = false;
            el.shrink();
        })
    }
    expand() {
        this.isExpanding = true;
        const summaryStyle = window.getComputedStyle(this.summary);
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.details.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
        this.details.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.style.height = this.details.style.overflow = '';
    }
}
customElements.define('accordion-tab', AccordionTab);